import { all } from 'redux-saga/effects';
import consultaPesquisaNomeSocialFiliacaoSaga from './consultaPesquisaNomeSocialFiliacao/saga';

export default all([consultaPesquisaNomeSocialFiliacaoSaga]);
